// Entry file for dst-forum. Necessary for correct code splitting. Do not update!
// TODO: Revisit or find better way to ensure versioning.

import { init } from './header.ts';

// TODO: remove when top level await is supported across browser targets (see https://caniuse.com/mdn-javascript_operators_await_top_level)
(async () => {
	await init();
})();
